import React, {useEffect, useState} from 'react';
import IMG from "../../constants/image";
import './style.css';
import StoreForm from "./StoreForm";
import {useLocation, useNavigate} from "react-router-dom";
import {updateMerchantProfile} from "../../network/api";
import {PATH} from "../../constants";
import popupStore from "../../store/popupStore";
import merchantStore from "../../store/merchantStore";
import {text} from "../../constants/text";
import {clsx} from "clsx";
import appStore from "../../store/appStore";

const StoreInfoComponent = () => {
    const {setPopup} = popupStore() || {}
    const {getMerchantProfile} = merchantStore() || {};
    const {fromNativeApp} = appStore();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    // Retrieve individual parameters
    const editingParam = searchParams.get('editing');
    const [editing, setEditing] = useState(!!editingParam);

    useEffect(() => {
        setEditing(!!editingParam);
    }, [editingParam]);

    const toggleEdit = (e) => {
        e && e.preventDefault();
        setEditing(!editing);
    }

    const onUpdateData = async ({newFormData}) => {
        const res = await updateMerchantProfile(newFormData);
        if (res?.success) {
            await getMerchantProfile();
            setPopup({
                isOpen: true,
                data: {
                    title: 'Bạn đã cập nhật thông tin cửa hàng thành công',
                    image: IMG.popupUpdateStatus,
                    autoAccept: 8,
                    desc: 'Trang web đang tự động chuyển đến trang Quản lý sản phẩm',
                    accept: {
                        label: 'Về trang Quản lý sản phẩm',
                        action: () => {
                            setPopup({})
                            navigate(PATH.MANAGING_PRODUCT)
                        }
                    }
                }
            })
        }
    }

    return (
        <div className='relative w-fit bg-[#EDEDED] md:bg-[#FAFAFC] animate-fadeIn md:pt-8'>
            <div className='hidden relative md:flex gap-[5px] justify-center items-center mb-5'>
                <img className='w-6 h-6' src={IMG.icon.storeGreen} alt="storeGreen"/>
                <p className='text-sm md:text-xl font-bold'>Thông tin cửa hàng</p>
                {!editing ? <img className='absolute right-5 cursor-pointer' src={IMG.icon.pencil} alt="edit"
                                 onClick={toggleEdit}/> : ''}
            </div>
            <div
                className={clsx(
                    'md:hidden fixed right-5 cursor-pointer z-[100] flex items-center justify-center space-x-1 text-sm text-white',
                    fromNativeApp ? 'top-[71px]' : 'top-[28px]'
                )}>
                <img className=''
                     src={IMG.icon.pencilLight}
                     alt="edit"
                     onClick={toggleEdit}/>
                <div>{text.edit}</div>
            </div>
            <StoreForm editing={editing} setEditing={toggleEdit} onUpdateData={onUpdateData}/>
        </div>
    );
}

export default StoreInfoComponent;